import React, { useEffect } from 'react';

import {
  Container,
  InfoBanner,
  InfoBannerText,
  Item,
  ItemName,
  ItemTitle,
  Section,
} from './styles';

import { RFValue } from 'react-native-responsive-fontsize';
import { ParcelasDTO } from '../../../../../../../dtos/ParcelasDTO';
import { useHelpers } from '../../../../../../../context/helpers';
//import { useTheme } from 'styled-components/native';
import { useGlobal } from '../../../../../../../context/global';

type Props = {
  placa: string;
  totalValue: number;
  installment?: ParcelasDTO | null;
  serviceTaxValue: number;
  serviceTaxIsCard: boolean;
  baseValue: number;
  usaBaratinhas: boolean;
  descontoBaratinhas: number;
};

export function VehicleDebitsResume({
  placa,
  totalValue,
  serviceTaxValue,
  serviceTaxIsCard,
  usaBaratinhas,
  descontoBaratinhas,

  installment,
}: Props) {
  const { ativaTaxaConv, fetchRemoteConfigTaxaConv, fetchPrazoDebitosPayment, prazoDebitosPayment } = useGlobal();

  function transformaMoeda(value: number) {
    return value.toLocaleString('pt-BR', {
      currency: 'BRL',
      style: 'currency',
    });
  }

  const { formatNumberToLocaleAmount } = useHelpers();
  useEffect(() => {
    fetchRemoteConfigTaxaConv();
    fetchPrazoDebitosPayment();
  }, []);

  //const theme = useTheme();

  return (
    <Container>

      <InfoBanner>
        <InfoBannerText>
          Prazo médio de quitação dos seus débitos junto aos orgãos:{' '}
          <InfoBannerText style={{ fontWeight: 'bold' }}>
            {prazoDebitosPayment}.{' '}
          </InfoBannerText>
        </InfoBannerText>
      </InfoBanner>

      <Section style={{ paddingBottom: RFValue(6) }}>
        <Item>
          <ItemTitle>Placa</ItemTitle>
          <ItemName style={{ textTransform: 'uppercase' }}>{placa}</ItemName>
        </Item>
        {/**baseValue && (
          <Item>
            <ItemTitle>Subtotal</ItemTitle>
            <ItemName>{transformaMoeda(baseValue)}</ItemName>
          </Item>
        )**/}
        {!serviceTaxIsCard && serviceTaxValue > 0 && (
          <Item>
            <ItemTitle>Taxa</ItemTitle>
            <ItemName>{transformaMoeda(serviceTaxValue)}</ItemName>
          </Item>
        )}

        {ativaTaxaConv && installment && installment.conveniencia > 0 && (
          <Item>
            <ItemTitle>Conveniência</ItemTitle>
            <ItemName>
              {formatNumberToLocaleAmount(installment.conveniencia)}
            </ItemName>
          </Item>
        )}

        {usaBaratinhas && (
          <Item>
            <ItemTitle>BaratinhaZ</ItemTitle>
            <ItemName>
              -{formatNumberToLocaleAmount(descontoBaratinhas)}
            </ItemName>
          </Item>
        )}

        {serviceTaxIsCard && serviceTaxValue > 0 && (
          <>
            <Item>
              <ItemTitle>Juros (Menor do Brasil)</ItemTitle>
              <ItemName>
                {serviceTaxValue.toFixed(2).replace('.', ',') + '% a.m'}
              </ItemName>
            </Item>
          </>
        )}

        {totalValue && (
          <Item>
            <ItemTitle>Total</ItemTitle>
            <ItemName>{transformaMoeda(totalValue)}</ItemName>
          </Item>
        )}
      </Section>
    </Container>
  );
}
